module.exports = __webpack_public_path__ + "static/media/FEED ROLLER.30577a40.jpg";